import { createContext, useContext } from "react";
import { useParams } from "react-router";

import { useCNaughtPortfolios } from "../components/projects";

const PortfoliosContext = createContext();

export const PortfoliosContextProvider = ({
  displayPageUrl,
  selectedPortfolioId: controlledPortfolioId,
  onPortfolioSelect,
  children
}) => {
  const [portfolios, portfoliosLoading, portfoliosError] =
    useCNaughtPortfolios();

  const { view: viewParam } = useParams();

  const effectivePortfolioId =
    controlledPortfolioId !== undefined ? controlledPortfolioId : viewParam;

  const selectedPortfolio =
    portfolios.find(({ id }) => id === effectivePortfolioId) || portfolios[0];

  return (
    <PortfoliosContext.Provider
      value={{
        displayPageUrl,
        portfolios,
        selectedPortfolio,
        portfoliosLoading,
        portfoliosError,
        onPortfolioSelect
      }}
    >
      {children}
    </PortfoliosContext.Provider>
  );
};

const usePortfoliosContext = () => useContext(PortfoliosContext);
export default usePortfoliosContext;
